import { toast } from 'react-toastify';
import * as api from './api';
import * as reducer from './reducer';
import * as taskReducer from './reducerForTask'
import {
  courseQuizResultsReducer,
  courseVideoPlayerActivityReducer,
  setProfileCoursesLessonReducer,
  setGroupLiveChatHistoryReducer,
  getPointReducer,
  getTopMemberReduce,
  setTaskColumnsReducer
} from './reducer';
import { setShopReducer } from '../../shop/store/reducer';
import { error, success } from '../../ui-elements/response-popup';

const location = JSON.parse(localStorage.getItem('location'));
const contactId = location && location.contactId;

// *** community
export const getCommunityDetailsAction = (payload) => async (dispatch) => {
  
  try{
    const { data } = await api.getCommunity(payload);
    if (data && data.success) {
      dispatch(reducer.setCommunityReducer(data.data));
      return data.data;
    }
  }
  catch(error){
    return  error
  }
  
};
export const getContactCommunityPostsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getContactCommunityPosts(payload);
    console.log("before if block in action",data)
    if (data && data?.success === true) {
      if (payload?.resetDataAfterDeletion) {
        dispatch(reducer.resetPostWithNewPosts(data.data));
      } else {
        dispatch(reducer.setPostsReducer(data.data));
      }
      return data.data;
    }
  } catch (error) {}
};



export const leaderboardSettingAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.leaderboardSettingApi(payload);
    if (data && data.success === true) {
      dispatch(reducer.leaderboardSettingReducer(data?.data));
    }
  } catch (error) {}
};

export const getCommunityOwnerAction = (payload) => async (dispatch) => {
  const { data } = await api.getCommunityOwner(payload);
  if (data && data.success) {
    dispatch(reducer.setCommunityOwnerReducer(data.data));
    return data.data;
  }
};

export const getCommunityRecentNewsAction = (payload) => async (dispatch) => {
  const { data } = await api.getRecentNews(payload);
  if (data && data.success) {
    dispatch(reducer.setRecentNewsReducer(data.data));
  }
};

// *** community members
export const getCommunityMembersAction = (payload) => async (dispatch) => {
  try {
    if (!payload?.noloader) {
      dispatch(reducer.setToggleMembersDataLoading());
    }
    const { data } = await api.getCommunityMembers({ ...payload });
    if (data && data?.success === true) {
      dispatch(reducer.setMembersReducer(data.data));
      dispatch(reducer.setMembersTotalCountReducer(data?.totalMembers));

      return data.data;
    }
  } catch (err) {
    if (err?.response?.status === 403) {
      error('Token Expired, Login to Continue.');
    }
  } finally {
    if (!payload?.noloader) {
      dispatch(reducer.setToggleMembersDataLoading());
    }
  }
};

export const getCommunityMemberByCommunityIdAction = (payload) => async (dispatch) => {
   try {
    const { data } = await api.getCommunityMembersList(payload);
    if (data && data.success) {
      return data.data;
    }
  }catch(error) {}
}

export const getCommunityMemberByContactIdIdAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getCommunityMemberByContactId(payload);
    if (data && data.success) {
      return data.data;
    }
  }catch(error) {}
}

export const getCommunityFavoriteMembersAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getCommunityFavoriteMembers(payload);
    if (data && data?.success === true) {
      //dispatch(reducer.setStarMembersReducer(data.data));
      return data.data;
    }
  } catch (error) {}
};

export const getCommunityGroupsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getCommunityGroups(payload);
    if (data && data?.success === true) {
      dispatch(reducer.setGroupsReducer(data.data));
      return data.data;
    }
  } catch (error) {}
};

export const getCommunityGroupsByUserAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getCommunityGroupsByUser(payload);
    if (data && data?.success === true) {
      dispatch(reducer.setGroupsReducer(data.data));
      return data.data;
    }
  } catch (error) {}
};

export const getCommunityMembersInvitedByContactAction = (payload) => async (dispatch) => {
  try {
    dispatch(reducer.setToggleMembersDataLoading());
    const { data } = await api.getCommunityInvitedByContact({ ...payload, contactId: contactId });
    if (data && data?.success === true) {
      dispatch(reducer.setMembersReducer(data.data));
    }
  } catch (error) {
  } finally {
    dispatch(reducer.setToggleMembersDataLoading());
  }
};
export const getCommunityMemberDetailsByIdAction = (id) => async (dispatch) => {
  const { data } = await api.getCommunityMemberDetailsById(id);
  if (data && data.success) {
    return data.data;
  }
};
export const updateCommunitySingleMemberProfile = (payload) => async (dispatch) => {
  const { data } = await api.updateCommunityMemberProfile(payload);
  if (data?.data && data?.success) {
    return dispatch(getCommunityMembersAction({ id: data?.data?.communityId })).then((respon) => {
      let item = respon?.find((i) => i.email === data?.data?.email);
      return item;
    });
  }
};

//*** community chat */
// export const getCommunityLiveChatMembersAction =(id) =>async(dispatch){
//   try {
//     const { data } = await api.getCommunityLiveChatMembers(id);
//     if (data && data?.success === true) {
//       dispatch(reducer.setLivChatMembers(data.data));
//     }
//   } catch (error) {}
// }

// ** FOLLOWING & FOLLOWERS
export const getFollowersAction = (payload) => async (dispatch) => {
  try {
    if (!payload?.noloader) {
      dispatch(reducer.setToggleMembersDataLoading());
    }
    const { data } = await api.getFollowers({ ...payload });
    console.log('data=====', data);
    if (data && data?.success === true) {
      dispatch(reducer.setProfileFollowersReducer(data.data));
      dispatch(reducer.setMembersReducer(data.data));
      dispatch(reducer.setMembersTotalCountReducer(data?.totalFollowers));
      return data.data;
    }
  } catch (error) {
  } finally {
    if (!payload?.noloader) {
      dispatch(reducer.setToggleMembersDataLoading());
    }
  }
};
export const getFollowingsAction = (payload) => async (dispatch) => {
  try {
    if (!payload?.noloader) {
      dispatch(reducer.setToggleMembersDataLoading());
    }
    const { data } = await api.getFollowings({ ...payload });
    console.log('data===== getFollowingsAction', data);
    if (data?.success) {
      dispatch(reducer.setMembersReducer(data.data));
      dispatch(reducer.setProfileFollowingReducer(data.data));
      dispatch(reducer.setMembersTotalCountReducer(data?.totalFollowing));
    }
  } catch (error) {
  } finally {
    if (!payload?.noloader) {
      dispatch(reducer.setToggleMembersDataLoading());
    }
  }
};
export const inviteMemberAction = (payload) => async (dispatch) => {
  try {
    dispatch(reducer.setToggleMembersDataLoading());
    const { data } = await api.inviteMember({ ...payload, invitedBy: contactId });
    if (data && data.success === true) {
      dispatch(getCommunityMembersInvitedByContactAction({ id: payload?.communityId }));
      success('Invitation Sent');
    }
  } catch (error) {
  } finally {
    dispatch(reducer.setToggleMembersDataLoading());
  }
};
export const deleteInvitedMemberAction = (id, communityId) => async (dispatch) => {
  try {
    const { data } = await api.removeInvitedMember(id);
    if (data && data.success === true) {
      dispatch(getCommunityMembersInvitedByContactAction({ id: communityId }));
      success('Invitation Removed');
    }
  } catch (error) {}
};
export const followAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.followContact(payload);
    if (data && data?.success === true) {
      if (!payload?.notFetchUnPaginatedData) {
        dispatch(getFollowingsAction({ contactId: contactId, communityId: payload.communityId }));
      }
      return data;
    }
  } catch (error) {}
};
export const unFollowAction =
  (followId, followingId, communityId, notFetchUnPaginatedData = false) =>
  async (dispatch) => {
    try {
      const { data } = await api.unfollowContact(followId, followingId);
      if (data && data?.success === true) {
        dispatch(reducer.setMembersReducer(data.data));
        if (communityId) {
          return dispatch(getFollowingsAction({ contactId: contactId, communityId: communityId }));
        }
        return data;
      }
    } catch (error) {}
  };
// *** Community group
export const getGroupsByCommunityAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getGroupsByCommunity({ ...payload });
    if (data && data.success) {
      dispatch(reducer.setGroupsReducer(data.data));
      return data.data;
    }
  } catch (error) {}
};
export const getGroupsByCommunityApprovedAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getGroupsByCommunityApproved({ ...payload });
    if (data && data.success) {
      dispatch(reducer.setGroupsReducer(data.data));
      return data;
    }
  } catch (error) {}
};
export const getGroupsByContactAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getGroupByContactId({ ...payload, contactId: contactId });
    if (data && data.success) {
      dispatch(reducer.setProfileGroupsReducer(data.data));
    }
  } catch (error) {}
};

export const getGroupDetailsAction = ({id, contactId}) => async (dispatch) => {
  try {
    const { data } = await api.getGroupDetails(id, contactId);
    if (data && data.success) {
      dispatch(reducer.setgroupDetailsReducer(data.data));
    }
  } catch (error) {}
};

export const markMessageReadAction = (payload) => async () => {
  try {
    const { data } = await api.markMessageRead(payload);
    if (data && data.success) {
      return data;
    }
  } catch (error) {}
}

// *** group members
export const requestToJoinGroupAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.requestToJoinGroup({ ...payload, contactIds: [contactId] });
    if (data && data.success) {
      toast.success('Requested');
      dispatch(getGroupsByCommunityAction({ id: payload.communityId, privacy: 'public' }));
    } else {
      toast.error('Joined failed');
    }
  } catch (error) {}
};

export const getGroupMembersAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getGroupMembers({ ...payload, contactId: contactId });
    if (data && data.success) {
      dispatch(reducer.setGroupMembersReducer(data.data));
    }
  } catch (error) {}
};

// ** Group members
export const getCommunityPostsAction = (payload) => async (dispatch) => {
  if (!payload?.communityId) {
    return;
  }
  try {
    const { data } = await api.getCommunityPosts(payload);
    if (data && data?.success === true) {
      if (data.data?.length) {
        if (payload.resetPost) {
          dispatch(reducer.resetPostWithNewPosts(data.data));
        } else {
          dispatch(reducer.setPostsReducer(data.data));
        }
      }
      return data.data;
    }
  } catch (error) {}
};

//Pin Post
export const pinCommunityPost = (payload) => async (dispatch) => {
  try {
    const { data } = await api.pinCommunityPost(payload);
    if (data && data?.success === true) {
      success('Your Post is Pinned');
      return data;
    } else {
      error('Unsuccessful');
      return 'error';
    }
  } catch (error) {}
};
export const unpinCommunityPost = (payload) => async (dispatch) => {
  try {
    const { data } = await api.unpinCommunityPost(payload);
    if (data && data?.success === true) {
      success('Your Post is Pinned');
      return data;
    } else {
      error('Unsuccessful');
      return 'error';
    }
  } catch (error) {}
};
export const getPinnedCommunityPosts = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getPinnedCommunityPosts(payload);
    if (data && data?.success === true) {
      // success('Your Post is Pinned');
      return data?.data;
    } else {
      error('Unsuccessful');
      return 'error';
    }
  } catch (error) {}
};

// GROUP POSTS
export const getGroupPostsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getGroupPosts(payload);
    if (data && data?.success === true) {
      if (payload?.fetchAfterDeletion) {
        dispatch(reducer.resetPostWithNewPosts(data.data));
      } else {
        dispatch(getCommunityPostsAction({ communityId: payload.communityId }));
        dispatch(reducer.setPostsReducer(data.data));
        return data;
      }
      return data.data;
    }
  } catch (error) {}
};
export const getContactPostsAction = (payload, communityId) => async (dispatch) => {
  try {
    const { data } = await api.getContactPosts({ contactId: contactId, ...payload });
    if (data && data?.success === true) {
      dispatch(reducer.setPostsReducer(data.data));
    } else {
      dispatch(getCommunityPostsAction({ communityId: communityId }));
    }
  } catch (error) {}
};
export const addPostAction = (payload, type) => async (dispatch) => {
  try {
    const { data } = await api.addPost({ contactId: contactId, ...payload });
    if (data && data?.success === true) {
      if (type === 'group') {
        await dispatch(getGroupPostsAction({ groupId: payload.groupId }, type));
        return data;
      } else {
        dispatch(getCommunityPostsAction({ communityId: payload.communityId }));
        return data;
      }
    } else {
      error('Unsuccessful post upload');
      return 'error';
    }
  } catch (error) {}
};
export const editPostAction = (id, payload, type) => async (dispatch) => {
  try {
    const { data } = await api.editPost(id, { contactId: contactId, ...payload });

    if (data && data?.success === true) {
      if (type === 'group') {
        await dispatch(getGroupPostsAction({ groupId: payload.groupId }, type));
        return data;
      } else {
        dispatch(getCommunityPostsAction({ communityId: payload.communityId }));
        return data;
      }
    } else {
      error('Unsuccessful post update');
      return 'error';
    }
  } catch (err) {
    console.error('Edit post error:', err);
    return 'error';
  }
};
export const deletePostAction = (id, type, communityId, groupId) => async (dispatch) => {
  try {
    const { data } = await api.deletePost(id);
    if (data && data?.success === true) {
      if (type === 'group') {
        dispatch(getGroupPostsAction({ groupId: groupId, fetchAfterDeletion: true }));
      } else {
        dispatch(getCommunityPostsAction({ communityId: communityId }));
      }
    }
  } catch (error) {}
};

// export const editPostAction = (id, payload, type, communityId, groupId) => async (dispatch) => {
//   try {
//     const { data } = await api.editPost(id, payload);
//     if (data && data?.success === true) {
//       if (type === 'group') {
//         dispatch(getGroupPostsAction({ groupId: groupId, fetchAfterEdit: true }));
//       } else {
//         dispatch(getCommunityPostsAction({ communityId: communityId }));
//       }
//       return data;
//     }
//     return { success: false };
//   } catch (error) {
//     console.error('Error editing post:', error);
//     return { success: false, error };
//   }
// };
export async function likeCommunityPostAction(payload, dispatch, type) {
  try {
    const { data } = await api.likeCommunityPost(payload);
    if (data && data?.success === true) {
      if (type === 'group') {
        dispatch(getGroupPostsAction({ groupId: payload.groupId }));
      } else {
        dispatch(getCommunityPostsAction({ communityId: payload.communityId }));
      }
      return data
    }
  } catch (error) {}
}

export async function dislikeCommunityPostAction(payload, dispatch, type) {
  console.log('payload==', payload);
  try {
    const { data } = await api.dislikeCommunityPost(payload);
    if (data && data?.success === true) {
      if (type === 'group') {
        dispatch(getGroupPostsAction({ groupId: payload.groupId, type }));
      } else {
        dispatch(getContactCommunityPostsAction({ communityId: payload.communityId }));
      }
      return data;
    }
  } catch (error) {}
}

export const createCommunityPostReport = (payload) => async (dispatch) => {
  try {
    const { data } = await api.createPostReport(payload);
    if (data && data?.success === true) {
      success('Your Report Saved.');
      return data;
    } else {
      error('Unsuccessful Report.');
      return 'error';
    }
  } catch (error) {}
};

//Profile
export const getProfileRanksAction = () => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfileRanks(contactId);
    if (data && data?.success === true) {
      dispatch(reducer.setProfileRankReducer(data.data));
    }
  } catch (error) {}
};
export const getContactCurrentRankAction = (contactId) => async (dispatch) => {
  try {
    const { data } = await api.getContactCurrentRank(contactId);
    if (data && data?.success === true) {
      let t = [];
      for (const r of data.data) {
        t.push({ ...r, label: r.currentRank.rankName, value: r.currentRank._id });
      }
      return t;
    }
  } catch (error) {}
};

export const getProfileAchievementsAction = () => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfileAchievements(contactId);
    dispatch(reducer.setProfileArchievementReducer(data));
  } catch (error) {}
};

// course
export const getProfileCoursesAction = (contactId) => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfileCourses(contactId);
    dispatch(reducer.setProfileCoursesReducer(data));
    return data;
  } catch (error) {}
};
// course two
export const getProfileCoursesActionHomepage = (payload) => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfileCoursesHomepage({ contactId, payload });
    dispatch(reducer.setProfileCoursesReducerHomepage(data));
    return data;
  } catch (error) {}
};

export const getProfileCourseByCourseIdAction = (courseId) => async () => {
  try {
    const { data } = await api.getProfileCourseByCourseId(courseId);
    return data;
  } catch (error) {}
};

// course quiz

export const submitQuizResultAction = (payload) => async (dispatch) => {
  const { data } = await api.submitQuizResult(payload);
  if (data.success) {
    success('Quiz Submitted');
    dispatch(getQuizResultsAction(payload?.invoiceId, payload?.courseId, 'short'));
  } else {
    error('Submission Failed');
  }
};

export const getQuizResultsAction = (invoiceId, courseId, resultType) => async (dispatch) => {
  const { data } = await api.getAllQuizResults(invoiceId, courseId, resultType);
  if (data?.success) {
    dispatch(courseQuizResultsReducer(data?.data));
  }
};


export const getQuizAnswersAction = ({invoiceId, quizId}) => async () => {
  const { data } = await api.getQuizAnswers(invoiceId, quizId);
 return data;
};

export const getRecordedWatchedTimeAction = (invoiceId) => async () => {
  const data = await api.getRecordWatchTime(invoiceId);
  return data?.data?.videoWatchTimes;
};

export const recordWatchedTimeAction =
  (invoiceId, videoId, currentWatchedTime) => async (dispatch) => {
    const { data } = await api.recordWatchTime(invoiceId, videoId, currentWatchedTime);
    if (data?.success) {
      return await dispatch(getRecordedWatchedTimeAction(invoiceId));
    }
  };

export const getCourseVideoPlayerActivityAction = (courseId, invoiceId,contactId) => async (dispatch) => {
  const { data } = await api.getCourseVideoPlayerActivity(courseId, invoiceId,contactId);
  if (data?.success) {
    dispatch(courseVideoPlayerActivityReducer(data?.data));
    return data;
  }
};

export const getCourseCompleteProgressReportAction = (courseId, invoiceId) => async () => {
  const { data } = await api.getCourseCompleteProgressReport(courseId, invoiceId);
  if (data?.success) {
    return data?.data;
  }
};

export const getAuthorTotalCourseCountAction = (userId) => async () => {
  const { data } = await api.getAuthorTotalCourseCount(userId);
  if (data?.success) {
    return data?.courseCount;
  }
};

export const getCardProgressReportAction = (payload) => async () => {
  const { data } = await api.getCardProgressReportAPI(payload);
  return data;
};

export const getCurrentCourseStudentCountAction = (courseId) => async () => {
  const { data } = await api.getCurrentCourseStudentCount(courseId);
  if (data?.success) {
    return data?.studentsCount;
  }
};

export const updateCourseVideoPlayerActivityAction =
  (courseId, invoiceId, courseVideoSettings) => async (dispatch) => {
    const { data } = await api.updateCourseVideoPlayerActivity(
      courseId,
      invoiceId,
      courseVideoSettings
    );
    if (data?.success) {
      dispatch(getCourseVideoPlayerActivityAction(courseId, invoiceId));
    }
  };

export const getLessonsByCourseIdAction = (payload) => async (dispatch) => {
  const { data } = await api.getLessonsByCourseId(payload);
  if (data.success) {
    dispatch(setProfileCoursesLessonReducer(data));
    return data;
  }
};

export const getCourseAssetsAction = (courseId) => async (dispatch) => {
  try {
    const { data } = await api.getCourseAssets(courseId);
    if (data?.success) {
      dispatch(reducer.setActiveCourseAssets(data?.data));
      return data.data;
    }
  } catch (error) {}
};

export const getCourseCertificateAction = (courseId, studentId) => async (dispatch) => {
  try {
    const { data } = await api.getCourseCertificate(courseId, studentId);
    if (data.success) {
      return data.data;
    }
  } catch (error) {}
};

export const getProfileContractsAction = () => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfileContracts(contactId);
    if (data && data?.success === true) {
      dispatch(reducer.setProfileContractsReducer(data?.data));
    }
  } catch (error) {}
};

export const getProfileTasksAction = () => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfileTasks(contactId);
    if (data && data?.success === true) {
      dispatch(reducer.setProfileTasksReducer(data.data));
    }
  } catch (error) {}
};

export const sharedGoalAction = () => async (dispatch) => {
  try {
    const { data } = await api.sharedGoalApi({
      contactId: contactId,
      userId: location.assignerId,
      organizationId: location.organizationId
    });
    if (data.success === true) {
      dispatch(reducer.sharedGoalReducer(data.data));
    }
  } catch (err) {}
};
export const setGoalAction = (goal) => async (dispatch) => {
  dispatch(reducer.selectGoal(goal));
};
export const subGoalsFetchAction = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchSubGoals(id);
    if (data?.success) {
      dispatch(reducer.fetchSubGoals(data.data));
    } else {
      dispatch(reducer.fetchSubGoals([]));
    }
  } catch (error) {}
};
export const fetchGoal = (id) => async (dispatch) => {
  try {
    const { data } = await api.getGoal(id);
    if (data.success) {
      dispatch(reducer.selectGoal(data.data));
      dispatch(subGoalsFetchAction(id));
    }
  } catch {}
};
export const goalsEditAction =
  (id, workspaceId, payload, contactId, userId) => async (dispatch) => {
    try {
      const { data } = await api.editGoals(payload, id);
      if (data.success === true) {
        success('Goal updated successfully.');
        dispatch(sharedGoalAction({ contactId: contactId, userId: userId }));
      } else {
        error('Something happend wrong.');
      }
    } catch (err) {
      error(err.message);
    }
  };
export const getProfileEventsAction = () => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfileEvents(contactId);

    if (data && data.success === true) {
      dispatch(reducer.setProfileEventsReducer(data.data));
    }
  } catch (error) {}
};

export const getProfileOrdersAction = (payload) => async (dispatch) => {
  try {
    if (!payload?.contactId) {
      return;
    }
    const { data } = await api.getProfileOrders(payload?.contactId, payload);
    dispatch(reducer.setProfileOrdersReducer(data?.data));
  } catch (error) {}
};

export const getProfileFilesAction = () => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfileFiles(contactId);
    if (data && data?.success === true) {
      dispatch(reducer.setProfileFilesReducer(data.data));
    }
  } catch (error) {}
};

export const getProfileAction = (contactId) => async (dispatch) => {
  try {
    if (!contactId) {
      return;
    }
    const { data } = await api.getProfile(contactId);
    dispatch(reducer.setProfileReducer(data));
  } catch (error) {}
};
export const getFamilyMembersAction = (payload) => async (dispatch) => {
  try {
    // if (!payload.contactId) {
    //   return;
    // }
    const { data } = await api.getFamilyMembers({
      contactId: payload?.contactId ? payload.contactId : contactId
    });
    let temp = [];
    if (data?.data) {
      for (const f of data.data) {
        temp.push({ ...f, label: f.fullName, value: f._id });
      }
    }
    dispatch(reducer.setFamilyMembersReducer(temp));
    dispatch(reducer.setMembersTotalCountReducer(data?.totalFamilyMambers));
    return data?.data;
  } catch (error) {}
};
export const addFamilyMemberAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.addFamilyMember({
      ...payload,
      contactId: payload.contactId
    });
    if (data && data?.success === true) {
      dispatch(getFamilyMembersAction({ contactId: payload.contactId }));
    }
  } catch (e) {
    error(e?.message);
  }
};

export const updateProfileAction = (contactId, updatedProfile) => async (dispatch) => {
  try {
    const { data } = await api.updateProfile(contactId, updatedProfile);
    if (data?.success) {
      const user = JSON.parse(window.localStorage.getItem('userData'));
      if (updatedProfile?.photo !== user?.avatar || updatedProfile?.fullName !== user?.fullName) {
        user.avatar = updatedProfile?.photo;
        user.fullName = updatedProfile?.fullName;
        localStorage.setItem('userData', JSON.stringify(user));
      }
      dispatch(getProfileAction(contactId));
      success(data?.message);
    } else {
      error(data?.error || 'Unsuccessful update your profile!');
    }
  } catch (error) {}
};
//notifications
export const getNotificationsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getNotifications(payload);
    if (data?.success) {
      dispatch(reducer.setNotificationsReducer(data.data));
    }
  } catch (error) {}
};

//Profile Payment Methods
export const getStripeCardsAction = (customerId) => async (dispatch) => {
  try {
    const { data } = await api.getContactStripeCards(customerId);
    return data;
  } catch (err) {}
};
export const insertContactStripeCardsAction = (customerId, payload) => async (dispatch) => {
  try {
    const { data } = await api.insertContactStripeCards(customerId, payload);
    if (data && data.success === true) {
      success('Card saved successfully');
      return dispatch(getStripeCardsAction(customerId));
    } else {
      error('Please try again');
    }
  } catch (err) {}
};
export const updateStripeCardsAction =
  (paymentMethodId, payload, customerId) => async (dispatch) => {
    try {
      const { data } = await api.updateContactStripeCards(paymentMethodId, payload);
      if (data && data.success === true) {
        return dispatch(getStripeCardsAction(customerId));
      } else {
        error('Please try again');
      }
    } catch (err) {}
  };
export const getStripeCustomerAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getStripeCustomer(payload);

    return data;
  } catch (error) {}
};
export const getShopByPathAction = (path) => async (dispatch) => {
  try {
    const { data } = await api.getShopByPath(path);
    if (data) {
      dispatch(setShopReducer(data || {}));
    }
  } catch (error) {}
};
export const getStripeCustomerDetailsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getStripeCustomerById({ ...payload, userId: location.assignerId });

    return data;
  } catch (error) {}
};
export const detatchContactStripeCardAction = (paymentMethodId) => async (dispatch) => {
  try {
    const { data } = await api.detatchContactStripeCard(paymentMethodId);

    return data;
  } catch (error) {}
};
export const updateStripeDefaultPaymentMethodAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.updateStripeDefaultPaymentMethod(payload);

    return data;
  } catch (error) {}
};
export const updateCardPaymentAction = (id, payload, isPublic) => async (dispatch) => {
  try {
    const { data } = await api.updateCardPayment(id, payload, isPublic);
    if (data) {
      toast.success('Payment processed');
      // dispatch(getInvoicesAction());
    }
    return data;
  } catch (errors) {
    // error('Unable to update invoice');
  }
};
// export const getInvoicesAction = (object) => async (dispatch) => {
//   try {
//     const { data } = await api.getInvoices(object);
//     if (data) {
//       dispatch(setInvoiceListReducer(data));
//     }
//   } catch (error) {}
// };
export const createNMITransactionAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.createNMITransaction(payload);

    return data;
  } catch (error) {}
};
export const createStripePaymentIntentAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.createIntent(payload);
    return data;
  } catch (error) {}
};
export const getDefaultPaymentAction = (options) => async (dispatch) => {
  try {
    const { data } = await api.getDefaultPayment(options);
    return data;
  } catch (error) {}
};
export const getStripeConfigAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getStripeConfig(payload);

    return data;
  } catch (error) {}
};

export const getNMICardsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getNMICards(payload);
    // if(data){

    // }
    return data;
  } catch (err) {}
};
export const addNMICardAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.addNMICard(payload);
    // if(data && data?.success === true){
    //   dispatch(getNMICardsAction(payload))
    // }
    return data;
  } catch (err) {}
};

// ADMIN DETAILS
export const getUserByIdAction = (id) => async (dispatch) => {
  try {
    const { data } = await api.getuserById(id);
    return data;
  } catch (error) {}
};

export const getShopByUserAction = () => async (dispatch) => {
  try {
    const { data } = await api.getShopByUser({
      userId: location.assignerId,
      organization: location.organizationId
    });
    if (data) {
      dispatch(setShopReducer(data || {}));
    }
    return data;
  } catch (error) {}
};
export const getShopByUserIdAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getShopByUser(payload);
    if (data) {
      dispatch(setShopReducer(data || {}));
    }
    return data;
  } catch (error) {}
};

// EVENTS & TOURNAMENTS

export const getEventsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getEvents(payload);

    if (data && data?.success === true) {
      dispatch(reducer.setEventsReducer(data.data));
    }
    return data;
  } catch (error) {}
};
export const getUpcomingEventsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getUpcomingEvents(payload);
    if (data && data?.success === true) {
      dispatch(reducer.setUpcommingEventsReducer(data.data));
    }
    return data;
  } catch (error) {}
};

//live chat
export const getCommunityChatListAction = () => async (dispatch) => {
  try {
    const { data } = await api.getCommunityChatList(contactId);
    if (data && data?.success === true) {
      dispatch(reducer.setCommunityChatListReducer(data.data));
    }
  } catch (error) {}
};
export const getCommunityOwnerChatsAction = () => async (dispatch) => {
  try {
    const { data } = await api.getCommunityOwnerChats(contactId);
    if (data && data?.success === true) {
      dispatch(reducer.setCommunityOwnerChatListReducer(data.data));
    }
    return data;
  } catch (error) {}
};

export const getCommunityChatMessagesAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getChatMessages(payload);
    if (data && data?.success === true) {
      dispatch(reducer.setCommunityContactChatsReducer(data?.data));
      return data.data;
    }
  } catch (error) {}
}

export const seenChatMessageAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.seenChatMessage(payload);
    return data;
  } catch (error) {}
}

export const getCommunityContactChatsAction = (receiver) => async (dispatch) => {
  try {
    const { data } = await api.getCommunityContactChats({ receiver: receiver, sender: contactId });
    if (data && data?.success === true) {
      dispatch(reducer.setCommunityContactChatsReducer(data.data));
    }
  } catch (error) {}
};

export const sendGroupChatMessageAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.sendGroupChatMessage(payload);
    if (data && data?.success === true) {
      dispatch(
        getCommunityGroupLiveChatHistoryAction({
          groupId: payload.groupId,
          communityId: payload.communityId,
          q: ''
        })
      );
    }
    return data;
  } catch (error) {}
};

export const sendChatMessageAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.sendChatMessage(payload);
    if (data && data?.success === true) {
      if (payload?.receiver) {
        dispatch(getCommunityContactChatsAction(payload.receiver));
      } else {
        dispatch(getCommunityOwnerChatsAction());
      }
    }
  } catch (error) {}
};

export const sendChatMessageDMAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.sendClientDm(payload);
    if (data && data?.success === true) {
      if (payload?.receiver && payload?.sender && payload?.communityId) {
        const payloadForChat = {
          receiver: payload.receiver,
          sender: payload.sender,
          communityId: payload.communityId
        }
        dispatch(getCommunityChatMessagesAction(payloadForChat));
      }else if (!payload?.receiver && payload?.sender && payload?.communityId){
          const payloadForChat = {
            sender: payload.sender,
            communityId: payload.communityId,
            receiver: null
          }
          dispatch(getCommunityChatMessagesAction(payloadForChat));
      }
    }
  } catch (error) {}
};

export const getCommunityGroupLiveChatHistoryAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getGroupLiveChatHistory(payload);
    if (data && data?.success === true) {
      dispatch(reducer.setGroupChatHistoryReducer(data.data));
    }
    return data;
  } catch (error) {}
};

//COMMUNITY
export const getCommunityBadgesAction = (communityId) => async (dispatch) => {
  if (!communityId) {
    return;
  }
  try {
    const { data } = await api.getCommunityBadges(communityId);
    if (data && data.success === true) {
      dispatch(reducer.setCommunityBadgesReducer(data.data));
    }
  } catch (error) {}
};
export const createCommunityBadgeAction = (payload, communityId) => async (dispatch) => {
  try {
    const { data } = await api.createCommunityBadge(payload);

    if (data && data.success === true) {
      dispatch(getCommunityBadgesAction(communityId));
      success('Badge Created');
    }
  } catch (error) {}
};
export const updateCommunityBadgeAction = (payload, communityId, badgeId) => async (dispatch) => {
  try {
    const { data } = await api.updateCommunityBadge(payload, badgeId);
    if (data && data.success === true) {
      dispatch(getCommunityBadgesAction(communityId));
      success('Badge Updated');
    }
  } catch (error) {}
};

export const deleteCommunityBagdeAction = (communityId, badgeId) => async (dispatch) => {
  try {
    const { data } = await api.deleteCommunityBadge(badgeId);
    if (data && data.success === true) {
      dispatch(getCommunityBadgesAction(communityId));
      success('Badge Updated');
    }
  } catch (error) {}
};

//Rewards and Points



//Rewards setting

export const getTopMemberAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getTopMemberApi(payload);
    if (data && data.success === true) {
      dispatch(getTopMemberReduce(data?.data));
    }
  } catch (error) {}
};

export const getAmbasdorAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getTopAmbasdorApi(payload);
    if (data && data.success === true) {
      dispatch(reducer.getTopAmbasdorReducer(data?.data));
    }
  } catch (error) {}
};
export const goalsEditActionMuted = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.editGoals(payload, id);
  } catch (error) {}
};

//events
export const getEventByIdAction = (id) => async (dispatch) => {
  try {
    const { data } = await api.getEventById(id);
    if (data) {
      return data;
    }
  } catch (error) {}
};
export const getEventTournamentDiviisonsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getEventTournamentDiviisons(payload);
    if (data && data?.success === true) {
      return data?.data;
    }
  } catch (error) {}
};
export const getEventTournamentEventssAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getEventTournamentEvents(payload);
    if (data && data?.success === true) {
      let temp = [];
      for (const e of data?.data) {
        temp.push({ ...e, label: e.title, value: e._id });
      }
      return temp;
    }
  } catch (error) {}
};
export const incomeCreateAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.createIncome(payload);
    if (data) {
      return data;
    }
  } catch (error) {}
};
export const incomeUpdateAction = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.updateIncome(id, payload);
    if (data) {
      return data;
    }
  } catch (error) {}
};
export const payStripeSavedCardsAction = (payload) => async (dispatch) => {
  try {
    const res = await api.payStripeSavedCards(payload);
    if (res?.data?.data) {
      return res?.data?.data;
    }
  } catch (e) {
    error(e?.message);
  }
};
//event
export const registerEventAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.registerEvent({
      ...payload
      // organizationId: location.organizationId,
      // userId: location.assignerId
    });

    if (data && data?.data) {
      success('Registration Successful');
      return data?.data;
    }
  } catch (e) {
    error(e?.message);
  }
};
export const updateGuestInEventAction = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.updateGuestInEvent(id, payload);

    if (data && data?.data) {
      success('Registration Successful');
      return data?.data;
    }
  } catch (e) {
    error(e?.message);
  }
};
export const isRegisteredInEventAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.isRegisteredInEvent(payload);
    if (data && data?.success === true) {
      return data;
    }
  } catch (e) {
    error(e?.message);
  }
};
export const tournamentCreateBracketAction = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.tournamentCreateBracket(id, payload);
  } catch (e) {
    error(e?.message);
  }
};

//RANKS
export const getProgressionCategoriesAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getProgressionCategories(payload);
    if (data && data?.success === true) {
      return data?.data;
    }
  } catch (e) {
    error(e?.message);
  }
};
export const getProgressionRanksAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getProgressionRanks(payload);
    if (data && data?.success === true) {
      return data?.data;
    }
  } catch (e) {
    error(e?.message);
  }
};
export const insertContactRankAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.insertContactRank(payload);
    if (data && data?.success === true) {
      success('Added successfully');
    }
  } catch (e) {
    error(e?.message);
  }
};
export const getEventMembershipsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getEventMemberships(payload);
    if (data && data?.success === true) {
      return data?.data;
    }
  } catch (e) {
    error(e?.message);
  }
};
export const getContactEventMembershipsActiveAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getContactEventMembershipsActive(payload);
    if (data && data?.success === true) {
      return data?.data;
    }
  } catch (e) {
    error(e?.message);
  }
};
export const getMyTaskWorkspaceAction = () => async (dispatch) => {
  try {
    const { data } = await api.getMyTaskWorkspaceApi();
    if (data && data?.success === true) {
      return data?.data?.invitiedWorkspaces;
    }
  } catch (e) {
    error(e?.message);
  }
};

export const getMyTaskBoardsAction = (workSpaceId) => async (dispatch) => {
  try {
    const { data } = await api.getMyTaskBoardsApi(workSpaceId);
    if (data && data?.success === true) {
      return data?.data;
    }
  } catch (e) {
    error(e?.message);
  }
};
export const getMyTaskColumnsAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getMyTaskColumnsApi(payload);
    if (data && data?.success === true) {
      dispatch(setTaskColumnsReducer(data?.data))
    }
  } catch (e) {
    error(e?.message);
  }
};

export const updateMyTaskStatusAction = (payload) => async () => {
  const { uuId, ...others } = payload;
  try {
    const { data } = await api.updateMyTaskStatusApi(uuId, others);

    if (data?.success) {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getSelfTaskAction = (payload) => async () => {
  try {
    const { data } = await api.getSelfTaskApi({contactId,payload});

    if (data?.success) {
      return data;
    }
  } catch (error) {
    throw error;
  }
};



export const createCommentAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.createCommentApi({creator:contactId,...payload});
    if (data?.success) {
      dispatch(
        getCommentAction({
          cardId: payload.cardId
        })
      );
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getCommentAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getCommentApi(payload);
    if (data?.success) {
      dispatch(taskReducer.setAllComments(data?.data));
    }
  } catch (error) {
    throw error;
  }
};

export const getMyProjectCardActivityAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getCardActivitiesApi(payload);
    if (data?.success) {
      dispatch(taskReducer.setBoardActivity(data?.data));
      return data?.data;
    }
  } catch (error) {
    throw error;
  }
};

export const upateProjectCardTodoAction = (payload) => async () => {
  try {
    const { data } = await api.updateCardTodosApi(payload);
    if (data?.success) {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getCardDetailsAction = (uuId) => async (dispatch) => {
  try {
    const { data } = await api.getCardDetailsApi(uuId);
    if (data?.success) {
      dispatch(taskReducer.setTaskDetails(data?.data))
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateMyProjectCardAction = (payload) => async (dispatch) => {
  const { uuId, ...others } = payload;
  try {
    const { data } = await api.updateMyProjectCardApi(uuId, others);
    if (data?.success) {
      dispatch(getCardDetailsAction(uuId))
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const menuLabelsGetAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.menuLabelsGetApi(payload);
    if (data?.success) {
      dispatch(taskReducer.setMenuLabelsList(data?.data));
    }
    return data?.success;
  } catch (error) {
    throw error;
  }
};

export const getBoardListOfWorkSpaceAction = (WorkspaceId) => async (dispatch) => {
  try {
    const { data } = await api.getBoardListOfWorkspaceApi(WorkspaceId);
    if (data?.success) {
      let temp = []
      for (const d of data?.data) {
        temp.push({...d,label:d?.title, value:d?._id})
      }
      return temp;
    }
  } catch (error) {
    throw error;
  }
};

export const getMyProjectColumnsFromCopyAndMoveAction = (payload) => async (dispatch) => {
  try {
    const { data } = await api.getMyProjectColumnsApi(payload);
    if (data?.success) {
      return data.data;
    }
  } catch (error) {
    throw error;
  }
};